import { useState } from "react";
import React from "react";

const initialState = {
  society: "",
  siret: "",
  email: "",
  message: "",
};

const initialError = {
  society: false,
  siret: false,
  email: false,
  message: false,
};

export const Contact = (props) => {
  const [{ society, siret, email, message }, setState] = useState(initialState);
  const [submitError, setSubmitError] = useState(initialError);

 const year = new Date().getFullYear()

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    function isValidSIRET(siret) {
      if (typeof siret !== "string") {
        return false;
    }
    
    // Supprimer les espaces éventuels dans la chaîne
    siret = siret.replace(/\s+/g, "");
    
    if (siret.length !== 14 || !/^[0-9]{14}$/.test(siret)) {
        return false;
    }

      // Algorithme de Luhn
      let sum = 0;
      for (let i = 0; i < 14; i++) {
        let num = parseInt(siret[i], 10);
        if (i % 2 === 0) { 
          num *= 2;
          if (num > 9) num -= 9;
        }
        sum += num;
      }
      return sum % 10 === 0;
    }

    function isValidEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    }

    if (isValidSIRET(siret) && isValidEmail(email) && society.length && message.length) {
      console.log("SEND MAIL");
      window.location.href = `mailto:${props.data.email}?subject=${society} - ${siret} :&body=${message}`;
      clearState();
    }
    else {
      switch (true) {
        case !isValidSIRET(siret):
          setSubmitError({ ...submitError, siret: true })
          console.log('SIRET NON VALIDE');
          break;
        case !isValidEmail(email):
          setSubmitError({ ...submitError, email: true })
          console.log('EMAIL NON VALIDE');
          break;
        case !society.length:
          setSubmitError({ ...submitError, society: true })
          console.log('SOCIETE NON VALIDE');
          break;
        case !message.length:
          setSubmitError({ ...submitError, message: true })
          console.log('MESSAGE NON VALIDE');
          break;
        default:
          break;
      }
    }
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Contactez nous</h2>
                <p>
                  Merci de nous laisser un message concernant votre demande, nous l'examinerons et reviendrons vers vous dès que possible.
                </p>
              </div>
              <form name="sentMessage" validate="true" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="society"
                        name="society"
                        className="form-control"
                        placeholder="Société"
                        required
                        value={society}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="siret"
                        name="siret"
                        className="form-control"
                        placeholder="Numéro siret"
                        required
                        value={siret}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    value={message}
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Envoyer
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Informations de contact</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Adresse
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Téléphone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
          {/* <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {year} B2i
          </p>
        </div>
      </div>
    </div>
  );
};
